module.exports = __webpack_public_path__ + "static/img/jqqd.8ec07be7.jpg";